import { EducationData } from 'models/education-data.interface'

export const certificationData: EducationData[] = [
	{
		dataType: 'education',
		title: 'Certification - Azure Fundamentals (AZ-900)',
		type: 'software',
		index: 3,
		description:
			'Knowledgable in cloud concepts, core Azure services, and how to use Azure management governance features and tools.',
		startYear: 2024,
		link: '/files/AzureFundamentalsCertification_AZ-900.pdf',
		org: '',
	},
]
